export default {
  image: 'Kapsel_2.png',
  pdf: '220829_WA-MIWO_020_Kapsel2_Rev02_ar.pdf',
  productData: {
    serialNumber: 'WA-MIWO-020',
    technicalValues: {
      soundReductionIndex: {
        output: '53,4',
        value: 53.4
      },
      heatTransferCoefficient: {
        output: '0,24',
        value: 0.24
      },
      fireBehavior: {
        output: 'nichtbrennbar (A2-s1, d0)',
        value: 'A1A2'
      },
      fireResistanceOuter: {
        output: 'F 60-B / K\u208260' ,
        value: 'F-60-B-K260'
      },
      fireResistanceInner: {
        output: 'F 60-B / K\u208260' ,
        value: 'F-60-B-K260'
      }
    },
    name: 'Wandaufbau mit Mineralwolle l Aufbau 20',
    construction: {
      composition: [
        {
          output: 'mineralischer Unterputz',
          type: 'render',
          title: { de: 'Putz' },
          value: 'min-1'
        },
        {
          output: '60 mm Sto-Speedlamelle Typ ll',
          type: 'pinsulation',
          title: { de: 'Dämmung' },
          value: 'msp-60'
        },
        {
          output: '12,5 mm Gipsfaserplatte',
          type: 'outerPlanking',
          title: { de: 'Beplankung Außen' },
          value: 'opg-12'
        },
        {
          output: '≥ 60/100',
          type: 'stand',
          title: { de: 'Ständer' },
          value: 'stae-100'
        },
        {
          output: '100 mm Steinwolle',
          type: 'compartmentInsulation',
          title: { de: 'Gefachdämmung' },
          value: 'cirw-100'
        },
        {
          output: '15 mm Gipsfaserplatte',
          type: 'innerPlanking1',
          title: { de: 'Beplankung Innen 1. Lage' },
          value: 'ig-15'
        },
        {
          output: '18 mm Gipsfaserplatte',
          type: 'innerPlanking2',
          title: { de: 'Beplankung Innen 2. Lage' },
          value: 'iq-18'
        }, 
        {
          output: 'keine',
          type: 'innerPlanking3',
          title: { de: 'Beplankung Innen 3. Lage' },
          value: null
        }
      ],
      sum: {
        output: '214,5',
        value: 214.5
      }
    }
  }
}
